import { LegacyAuthCookie } from "../models/auth";
import Settings from "../settings";
import { AuthHelper, Utility } from "../utils";
import { Log } from "../utils/Log";

export class LegacyApi {
    private _fetch: any = undefined; // typeof fetch !== "undefined" ? fetch : undefined;

    public constructor() {
    }

    /**
     * Sets the fetch method used internally to call api endpoints.
     * Useful for node express that doesn't know about browser's fetch/polyfill.
     * @param fetch The fetch methods
     */
    public setFetchMethod(fetch: any) {
        this._fetch = fetch;
    }

    /**
     * Makes a request to the legacy ASRS site to sign in user
     * @param username The legacy username
     * @param password The legacy password
     */
    public async authorize(username: string, password: string, passwordIsGuid: boolean = false) {
        try {
            const data: any = {
                source: "asrs.client",
                username,
                password,
                passwordIsGuid,
            };

            const dataEncoded = Object.keys(data)
                .filter((key: string) => {
                    return data[key] !== undefined && data[key] !== null;
                })
                .map((key: string) => {
                    if (data[key] !== undefined)
                        return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
                    else
                        return "";
                }).join("&");

            const init: RequestInit = {
                body: dataEncoded,
                credentials: "include", // needed to send along cookies
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                method: "Post",
            };

            const url = `${Settings.AsrsLegacyUrl}/user/login-via-app`;
            const response = await (this._fetch !== undefined ? this._fetch(url, init) : fetch(url, init));
            const respText = await response.text();

            if (response.ok) {
                try {
                    const obj = JSON.parse(respText);
                    if (obj.IsSuccess)
                        Log.info("legacy user signed in");
                    else
                        Log.warn("legacy user not signed in", obj.Errors);
                }
                catch (parseErr) {
                    Log.warn("legacy user not signed in", parseErr);
                }
            }
            else
                throw new Error(respText || response.statusText);
        }
        catch (err) {
            await AuthHelper.clearLegacyAuthCookie();
            Log.warn("Unable to login legacy user", err);
        }
    }

    /**
     * Makes a request to the legacy ASRS site to log out user
     * @param legacyAuthCookie The legacy auth cookie
     */
    public async logout(legacyAuthCookie: LegacyAuthCookie) {
        try {
            const data: any = {
                s: "asrs.client",
                m: legacyAuthCookie.m,
                u: legacyAuthCookie.u,
            };

            const dataEncoded = Object.keys(data)
                .filter((key: string) => {
                    return data[key] !== undefined && data[key] !== null;
                })
                .map((key: string) => {
                    if (data[key] !== undefined)
                        return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
                    else
                        return "";
                }).join("&");

            const init: RequestInit = {
                body: dataEncoded,
                credentials: "include", // needed to send along cookies
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                method: "Post",
            };

            const url = `${Settings.AsrsLegacyUrl}/user/logout-via-app`;
            const response = await (this._fetch !== undefined ? this._fetch(url, init) : fetch(url, init));
            const respText = await response.text();

            if (response.ok) {
                try {
                    const obj = JSON.parse(respText);
                    if (obj.IsSuccess)
                        Log.info("legacy user signed out");
                    else
                        Log.warn("legacy user not signed out", obj.Errors);
                }
                catch (parseErr) {
                    Log.warn("legacy user not signed out", parseErr);
                }
            }
            else
                throw new Error(respText || response.statusText);
        }
        catch (err) {
            await AuthHelper.clearLegacyAuthCookie();
            Log.warn("Unable to logout legacy user", err);
        }
    }

    /**
     * Makes a request to the legacy ASRS site to sign in user
     * @param imageUrl The legacy username
     * @param password The legacy password
     */
    public async updateMemberProfilePicture(imageUrl: string, legacyMemberId?: number) {
        try {
            const data: any = {
                imageUrl,
                memberId: legacyMemberId ? legacyMemberId : null,
            };

            const dataEncoded = Utility.queryParamsToUrl(data);

            const init: RequestInit = {
                body: dataEncoded,
                credentials: "include", // needed to send along cookies
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                method: "Post",
            };

            const url = `${Settings.AsrsLegacyUrl}/api/members/profile-picture`;
            const response = await (this._fetch !== undefined ? this._fetch(url, init) : fetch(url, init));
            const respText = await response.text();

            if (response.ok) {
                try {
                    const obj = JSON.parse(respText);
                    if (obj.IsSuccess)
                        console.info("Legacy profile picture updated");
                    else
                        console.warn("Failed to update legacy profile picture", obj.Errors);
                }
                catch (parseErr) {
                    console.warn(parseErr);
                }
            }
            else
                throw new Error(respText || response.statusText);
        }
        catch (err) {
            Log.warn("Unable to update legacy profile picture", err);
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/LegacyApi.ts